<template>
  <div class="content-container">
    <search-comp
      @onSearch="attachData"
      @onReset="
        () => {
          searchParams.searchingValue = ''
          attachData()
        }
      "
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Thông tin tìm kiếm</div>
                <div class="child-w-80">
                  <input
                    v-model="searchParams.searchingValue"
                    type="text"
                    placeholder="Nhập thông tin tên, mã bộ phận"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        class="agGrid"
        :auto-size-cell="true"
        @refresh="onRefresh"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :row-multi-select-with-click="true"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers mb-0">
      <button class="btn primary small outline" @click="deleteDepartment">
        {{ $t('button.delete') }}
      </button>
      <button class="btn primary small" @click="updateDepartmentView">
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
    </div>

    <el-dialog
      :title="!isEdit ? 'Thêm bộ phận' : 'Sửa bộ phận'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã bộ phận</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã bộ phận"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        :disabled="isEdit"
                        type="text"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Tên bộ phận</div>
                  <validation-provider
                    rules="required|max:50"
                    name="Tên bộ phận"
                  >
                    <input v-model="form.name" type="text" />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Mô tả</div>
                  <validation-provider rules="max:255" name="Mô tả bộ phận">
                    <textarea
                      v-model="form.description"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col">
                <div class="das-form-input">
                  <div class="label" />

                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp3"
                      v-model="form.record_empl"
                      type="checkbox"
                    />
                    <label for="cpSpdTp3"
                      >Ghi nhận doanh thu cho nhân viên</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateDepartment"
          >
            {{ $t('button.update') }}
          </button>
          <button
            v-else
            class="btn primary small outline"
            @click="addDepartment"
          >
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders.js'
import {
  getDepartmentApi,
  addDepartmentApi,
  deleteDepartmentApi,
  updateDepartmentApi
} from '@/api/userConfig/department'
import { Message } from 'element-ui'
export default {
  components: {
    CellRenderCheckboxReadonly
  },
  data() {
    return {
      defaultForm: {
        id: null,
        code: '',
        name: '',
        description: '',
        record_empl: false
      },
      form: {
        id: null,
        code: '',
        name: '',
        description: '',
        record_empl: false
      },
      titlePopup: 'Thêm bộ phận',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        searchingValue: ''
      },

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.departmentCode'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('grid.column.departmentName'),
          field: 'name',
          width: 150
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description'
          // cellRenderer: 'CellRenderTextInput',
        },
        {
          headerName: this.$t('grid.column.recordEmployee'),
          field: 'record_empl',
          // cellRenderer: 'CellRenderTextInput',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellRendererParams: params => {
            return {
              value: params.data.record_empl
            }
          },
          minWidth: 90
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetBuildingInfo()
    }
  },

  mounted() {
    this.attachData()
  },
  methods: {
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    async attachData() {
      let data = await getDepartmentApi(this.searchParams)
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : this.searchParams.pageNum
    },
    async addDepartment() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      this.form.name = this.form.name.trim()
      await addDepartmentApi(this.form)
        .then(data => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + data.message)
          })
          this.attachData()
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
    },
    async updateDepartment() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      this.form.name = this.form.name.trim()

      await updateDepartmentApi(this.form)
        .then(data => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + data.message)
          })
          this.attachData()
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
      // this.dialogFormVisible = false
      // this.$message({
      //   type: 'success',
      //   message: 'Bạn đã cập nhật bộ phận thành công'
      // })
      // this.attachData()
    },

    deleteDepartment() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$vxAlert('Bạn chưa chọn bộ phận!', 'Error', {
          confirmButtonText: 'OK'
        })
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn xoá bộ phận này?', async () => {
          await deleteDepartmentApi({ id_list: id_list })
            .then(data => {
              this.$message({
                type: 'success',
                message: this.$t('successMsg.' + data.message)
              })
              this.attachData()
            })
            .catch(err => {
              this.$message({
                type: 'error',
                message: this.$t('errorMsg.' + err.response.data.message)
              })
              this.dialogFormVisible = false
            })
        })
      }
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },

    updateDepartmentView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$vxAlert('Bạn vui lòng chọn 1 bộ phận để sửa')
      } else {
        this.titlePopup = 'Sửa bộ phận'
        this.isEdit = true
        const rowData = rowsSelected[0]
        this.form = { ...rowData }
        this.dialogFormVisible = true
      }
    },
    resetBuildingInfo() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
